import React, { createRef, useContext, useCallback, useState, useEffect } from 'react'
import { RedirectLinkButton } from './RedirectLinkButton'
import {SharedContext} from "../context/SharedContext"
import {SeekerContext} from "../context/SeekerContext"
import classNames from 'classnames'
import ImageWithBasePath from './ImageWithBasePath'
import domtoimage from 'dom-to-image'
import { formattedUrl, rediretionHandler, seekersAnalayticOptions } from '../utils/functions'
import { FooterModelForApplyJob } from './FooterModelForApplyJob'
import { JobCardFooter } from './JobCardFooter'
import { Media } from '../commonComponents/Media'
import { clog } from '../utils/functions'
import { NextLink } from '../commonComponents/NextLink'

export const AboutJob = ({
  jobDetails,
  showBottomDiv = true,
  showQualificationOnTop = false,
  className,
  showKebabMenu = true,
  sponsoredJobs = false
}) => {
  const ref = createRef(null)
  const { 
    loginDetails, 
    setShowToast 
  } = useContext(SharedContext);

  const { 
    setLogInOpen, 
    isJobProfileCreated 
  } = useContext(SeekerContext);
  const [showIsAppiledModel, setIsShowAppiledModel] = useState(false)

  const [isApplied, setIsApplied] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setIsApplied(jobDetails?.is_applied || false)
  }, [jobDetails?.is_applied])

  const jobCreativesLength = jobDetails?.creatives?.length - 1

  const allValues = {
    companyName: jobDetails?.company_name,
    title: jobDetails?.title,
    jobType: jobDetails?.primary_details?.Job_Type,
    salary: jobDetails?.primary_details?.Salary,
    place: jobDetails?.job_location_slug,
    experience: jobDetails?.primary_details?.Experience,
    jobHours: jobDetails?.job_hours,
    qualification: jobDetails?.primary_details?.Qualification,
    jobTags: jobDetails?.job_tags || []
  }

  const blocks = (value = '', icon = '', className = '') => {
    return (
      <div className={classNames('flex w-[50%] max-w-[50%] items-center', className)}>
        <div className="mr-[7.5px] flex items-center" id={icon}>
          <ImageWithBasePath src={icon} height={16} width={16} alt={`${value} symbol`} />
        </div>
        <div className="flex w-[80%] items-center">
          <div className="truncate leading-[22.4px] text-[#66676B]" id={value}>
            {value || '-'}
          </div>
        </div>
      </div>
    )
  }

  const place = () => {
    return blocks(
      allValues.place,
      'locationIcon',
      `border-[0px] border-r-[1px] border-solid border-r-[#E5E5E6] ${
        showQualificationOnTop ? 'pb-[0px]' : 'pb-[12px]'
      }`
    )
  }

  const qualification = (isJobHourPresent) => {
    return blocks(allValues.qualification, 'qualificationIcon', 'pl-[11.33px]')
  }

  const experience = () => {
    return blocks(allValues.experience, 'experienceIcon', ' pl-[11.33px] pb-[12px]')
  }

  const jobHours = () => {
    return blocks(
      allValues.jobHours,
      'jobHoursIcon',
      'border-[0px] border-r-[1px] border-solid border-r-[#E5E5E6]'
    )
  }

  const getImage = useCallback(async () => {
    if (ref.current === null) {
      return
    }
    const image = await domtoimage
      .toPng(ref.current, { backgroundColor: '#FFFFFF' })
      .catch((err) => {
        clog(err)
      })
    return image
  }, [ref])

  return (
    jobDetails?.job_role &&
    allValues.title && (
      <>
        <div
          className={classNames(
            'my-[12px] h-auto w-full cursor-pointer rounded-[4px] bg-[white] shadow-default',
            className
          )}
        >
          <NextLink
            id={jobDetails?.id}
            href={{
              pathname: 'jobDetails',
              query: { jobId: jobDetails.id }
            }}
            as={`jobs/${formattedUrl(
              jobDetails?.job_category || '',
              'category'
            )}-jobs-in-${formattedUrl(jobDetails?.job_location_slug || '')}-with-${formattedUrl(
              jobDetails?.primary_details?.Experience || '',
              'experience'
            )}-${jobDetails?.id}`}
          >
            <div style={{ textDecoration: 'none' }}>
              <div ref={ref} className="p-[12px]">
                <div className="flex w-[100%] items-center">
                  <div className="w-fit">
                    <ImageWithBasePath
                      src={jobDetails?.creatives?.[jobCreativesLength]?.file || 'anonymousIcon'}
                      isurl={jobDetails?.creatives?.[jobCreativesLength]?.file}
                      height={50}
                      width={50}
                      alt="company logo"
                      className="rounded-[4px]"
                    />
                  </div>
                  <div className="ml-[25px] w-[75%] sm:ml-[10px]" id="job_role">
                    {jobDetails?.job_role && (
                      <RedirectLinkButton
                        title={jobDetails?.job_role}
                        className="text-[16px] leading-[21.79px]"
                      />
                    )}
                    {allValues.companyName && (
                      <div
                        className="flex pt-[5px] font-noto-sans text-base leading-[19.07px] text-[#323232]"
                        id="companyName"
                      >
                        <div className="w-[200px] truncate text-start">{allValues.companyName}</div>
                      </div>
                    )}
                  </div>
                </div>
                {!sponsoredJobs && allValues.title && (
                  <div
                    className="my-[12px] font-noto-sans text-sm leading-[16.34px] text-[#66676B]"
                    id="job_title"
                  >
                    {allValues.title}
                  </div>
                )}
                {!sponsoredJobs && allValues.jobTags && (
                  // Here Scroll is a separate styling in global.css
                  <div className="scroll flex items-center" id="jobtags_conatiner">
                    {allValues.jobTags?.map((item, index) => (
                      <div
                        className={classNames(
                          'flex w-fit items-center rounded-[20px] px-[8px] py-[4px] font-noto-sans text-[11px] font-bold leading-[14.98px]',
                          index > 0 && 'ml-[4px]'
                        )}
                        style={{ backgroundColor: item?.bg_color, color: item?.text_color }}
                        key={index}
                        id={item.value}
                      >
                        {item.value}
                      </div>
                    ))}
                  </div>
                )}
                {allValues.salary && (
                  <div className="flex items-center py-[12px]" id="salary_div">
                    <div className="flex items-center" id="salary_icon">
                      <ImageWithBasePath
                        src="moneyIcon"
                        height={11}
                        width={16}
                        alt="salary symbol"
                      />
                    </div>
                    <h2
                      className="ml-[5px] mb-[0px] self-center truncate font-noto-sans text-base font-bold leading-[19.07px] text-[#191919]"
                      id="salary_figure"
                    >
                      {allValues.salary}
                    </h2>
                  </div>
                )}
                <div
                  className=" border-[0px] border-t-[1px] border-b-[1px] border-solid border-b-[#E5E5E6] border-t-[#E5E5E6] py-[12px]"
                  id="block_div"
                >
                  <div className="flex items-center" id="upper_block_items">
                    {place()}
                    {!showQualificationOnTop ? experience() : qualification()}
                  </div>
                  {showBottomDiv && (
                    <div className=" flex items-center" id="lower_block_div">
                      {jobHours()}
                      {qualification(allValues.jobHours)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </NextLink>
          <div
            className="flex items-center justify-between px-[12px] pb-[12px] sm:justify-end"
            id="functional_component_div"
          >
            <JobCardFooter
              {...{
                jobDetails,
                isApplied,
                showKebabMenu,
                setLoading,
                setIsApplied,
                getImage,
                sponsoredJobs
              }}
            />
          </div>
        </div>
        <Media at="sm">
          <FooterModelForApplyJob
            {...{
              setIsShowAppiledModel,
              rediretionHandler: (props) => {
                rediretionHandler({
                  ...props,
                  link: jobDetails?.custom_link,
                  loginDetails,
                  setLogInOpen,
                  isJobProfileCreated,
                  setLoading,
                  setIsApplied,
                  jobDetails,
                  setShowToast,
                  window
                })
              },
              showIsAppiledModel,
              isApplied,
              jobDetails,
              loading
            }}
          />
        </Media>
      </>
    )
  )
}
